import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceSadTear } from "@fortawesome/free-regular-svg-icons";

import INFO from "../data/user";

import "./styles/404.css";

const Notfound = () => {
	useEffect(() => {
		document.title = `404 | ${INFO.main.title}`;
	}, []);

	return (
		<React.Fragment>
			<div className="page-content">
				<div className="not-found">
					<div className="content-wrapper page-404">
						<div className="notfound-container">
							<div className="notfound-message">
								<div className="notfound-title">
									Oops!{" "}
									<FontAwesomeIcon icon={faFaceSadTear} />
								</div>
								<div className="not-found-message">
									We can't seem to find the page you're
									looking for.
									<br />
									The requested URL "{window.location.href}"
									was not found on this server.
								</div>
								<a href="/" className="not-found-link">
									Go back to the home page
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Notfound;
